module.exports = __webpack_public_path__ + "img/logo.01e76f71.svg";